import { defineComponent } from "vue";
import Avatar from "../../common/Avatar.vue.mjs";
import SvgIcon from "../../common/base/SvgIcon.vue.mjs";
import { isWeChat } from "../../../utils/environment.mjs";
import Dialog from "../../common/base/Dialog/index.mjs";
import "../../../directives/vTap.mjs";
import useMemberControl from "./useMemberControlHooks.mjs";
import { useI18n } from "../../../locales/index.mjs";
import "../../../services/main.mjs";
import { roomService } from "../../../services/roomService.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "mitt";
import "../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import Input from "../../common/base/Input/index.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MemberControlH5",
  props: {
    userInfo: null,
    showMemberControl: { type: Boolean }
  },
  emits: ["on-close-control"],
  setup(__props, { emit }) {
    const props = __props;
    const { t } = useI18n();
    const {
      controlList,
      handleCancelDialog,
      handleAction,
      isDialogVisible,
      dialogData,
      tempUserName,
      isShowInput,
      editorInputEleContainer,
      editorInputEle
    } = useMemberControl(props);
    function handleCloseControl() {
      isShowInput.value = false;
      emit("on-close-control");
    }
    function handleCloseInput(event) {
      if (isWeChat) {
        isShowInput.value = false;
      } else if (event.target !== event.currentTarget) {
        return;
      } else {
        isShowInput.value = false;
      }
    }
    return { __sfc: true, props, t, controlList, handleCancelDialog, handleAction, isDialogVisible, dialogData, tempUserName, isShowInput, editorInputEleContainer, editorInputEle, emit, handleCloseControl, handleCloseInput, Avatar, SvgIcon, isWeChat, Dialog, roomService, TuiInput: Input };
  }
});
export {
  _sfc_main as default
};
